import { useEffect, useState } from 'react';
import { Download } from 'lucide-react';
import api from '../utils/api';

function protectedEndpoint(reference, category) {
  if (!reference) return null;
  if (reference.startsWith('cloudinary-authenticated://')) {
    return `/cloud-files/${category}/${reference.slice('cloudinary-authenticated://'.length)}`;
  }
  let value = reference.replace(/\\/g, '/').replace(/^\/+/, '');
  const marker = '/uploads/';
  const markerIndex = value.indexOf(marker.slice(1));
  if (markerIndex >= 0) value = value.slice(markerIndex + marker.length - 1);
  if (value.startsWith('uploads/')) value = value.slice('uploads/'.length);
  if (!value.includes('/')) value = `${category}/${value}`;
  return `/files/${value.split('/').map(encodeURIComponent).join('/')}`;
}

export default function SecureImage({ reference, category, alt, className, style, downloadName }) {
  const [src, setSrc] = useState(reference?.startsWith('http') ? reference : null);

  useEffect(() => {
    if (!reference || reference.startsWith('http')) {
      setSrc(reference || null);
      return undefined;
    }
    let active = true;
    let objectUrl;
    const authenticatedCloud = reference.startsWith('cloudinary-authenticated://');
    api.get(protectedEndpoint(reference, category), authenticatedCloud ? {} : { responseType: 'blob' })
      .then((response) => {
        if (!active) return;
        if (authenticatedCloud) {
          setSrc(response.data.url);
        } else {
          objectUrl = URL.createObjectURL(response.data);
          setSrc(objectUrl);
        }
      })
      .catch(() => { if (active) setSrc(null); });
    return () => {
      active = false;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [reference, category]);

  if (!src) return <div className={className} style={style} aria-label={`${alt} unavailable`} />;

  const download = (event) => {
    event.stopPropagation();
    const link = document.createElement('a');
    link.href = src;
    link.download = downloadName || 'trusttrade-file';
    link.click();
  };

  return (
    <>
      <img src={src} alt={alt} className={className} style={style} onClick={() => window.open(src, '_blank', 'noopener,noreferrer')} />
      {downloadName && (
        <button type="button" onClick={download} className="absolute bottom-2 right-2 p-2 rounded bg-white shadow opacity-0 group-hover:opacity-100 transition-opacity" aria-label={`Download ${alt}`}>
          <Download className="w-4 h-4" />
        </button>
      )}
    </>
  );
}
